import _typeof from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import config from '@/pathConfig';
import selectPerson from '@/components/select-person';
import { getDocumentFillDataById, documentProcess, queryDocTodoDet, queryTempThreeContent, editNewDocumentState, printDocumentTemplate, editSystemNoticeState, issuedDocGather, downloadFile } from '@/api/notice/documentApi.js';
import printJS from 'print-js';
var Base64 = require('js-base64').Base64;
export default {
  data: function data() {
    var validateSendList = function validateSendList(rule, value, callback) {
      if (value.organData.length === 0 && value.postData.length === 0 && value.userData.length === 0) {
        callback(new Error('请选择下发到'));
      } else {
        callback();
      }
    };
    return {
      config: config,
      form: {
        result: '',
        tempId: -1,
        id: undefined,
        urgency: undefined,
        secretLevel: undefined,
        fileList: [],
        fileNameGroup: [],
        copyDelivery: {
          organData: [],
          postData: [],
          userData: []
        },
        csNameList: [],
        mainDelivery: {
          organData: [],
          postData: [],
          userData: [],
          organId: 0,
          postId: 0
        },
        zsNameList: [],
        title: '',
        fileName: '',
        fileCode: '',
        proposedsignimg: '',
        proposedsigndate: '',
        memorandumsignimg: '',
        memorandumsigndate: '',
        docData: {}
      },
      backto: '',
      title: '',
      previewSrc: '',
      previewShow: false,
      flowList: [],
      printSrc: '',
      fillData: {},
      distriVisible: false,
      options: [],
      userInfo: this.$hdk.userInfo.get(),
      sendForm: {
        docId: undefined,
        organPostId: [],
        dodId: undefined,
        isIssue: this.$route.query.isIssue,
        result: {
          organData: [],
          postData: [],
          userData: [],
          organId: 0,
          postId: 0
        }
      },
      needData: {},
      proposedOpinion: '',
      SecretaryOpinion: '',
      rules: {
        isIssue: [{
          required: true,
          message: '请选择是否继续下发',
          trigger: 'change'
        }],
        result: [{
          required: true,
          message: '请选择下发到',
          trigger: 'change',
          validator: validateSendList
        }]
      },
      columns: [{
        title: '会签人',
        dataIndex: 'userName',
        key: 'userName'
      }, {
        title: '会签状态',
        dataIndex: 'auditStatus',
        key: 'auditStatus',
        align: 'center',
        scopedSlots: {
          customRender: 'auditStatus'
        }
      }, {
        title: '会签时间',
        dataIndex: 'processTime',
        key: 'processTime'
      }],
      showUserData: []
    };
  },
  watch: {
    'form.mainDelivery': function formMainDelivery(n, o) {
      this.form.zsNameList = [];
      if (n.organData) {
        var organData = n.organData;
        if (organData.length > 0) {
          for (var i = 0; i < organData.length; i++) {
            this.form.zsNameList.push(organData[i].name);
          }
        }
      }
      if (n.postData) {
        var postData = n.postData;
        if (postData.length > 0) {
          for (var i = 0; i < postData.length; i++) {
            this.form.zsNameList.push(postData[i].name);
          }
        }
      }
      if (n.userData) {
        var userData = n.userData;
        if (userData.length > 0) {
          for (var i = 0; i < userData.length; i++) {
            this.form.zsNameList.push(userData[i].name);
          }
        }
      }
    },
    'form.copyDelivery': function formCopyDelivery(n, o) {
      this.form.csNameList = [];
      if (n.organData) {
        var organData = n.organData;
        if (organData.length > 0) {
          for (var i = 0; i < organData.length; i++) {
            this.form.csNameList.push(organData[i].name);
          }
        }
      }
      if (n.postData) {
        var postData = n.postData;
        if (postData.length > 0) {
          for (var i = 0; i < postData.length; i++) {
            this.form.csNameList.push(postData[i].name);
          }
        }
      }
      if (n.userData) {
        var userData = n.userData;
        if (userData.length > 0) {
          for (var i = 0; i < userData.length; i++) {
            this.form.csNameList.push(userData[i].name);
          }
        }
      }
    },
    'form.fileList': function formFileList(n, o) {
      if (n.length > 0) {
        this.form.fileNameGroup = [];
        for (var i = 0; i < n.length; i++) {
          this.form.fileNameGroup.push(n[i].name);
        }
      }
    }
  },
  methods: {
    backPage: function backPage() {
      this.$router.go(-1);
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value, option) {
      this.sendForm.result.organId = value[0];
      this.sendForm.result.postId = value[1];
      this.form.mainDelivery.organId = value[0];
      this.form.mainDelivery.postId = value[1];
    },
    distribute: function distribute() {
      var $route = this.$route;
      this.distriVisible = true;
      this.sendForm.docId = this.needData.id;
      this.sendForm.isIssue = parseInt($route.query.isIssue);
    },
    distriCancel: function distriCancel() {
      this.distriVisible = false;
      this.$refs.form.resetFields();
    },
    submitSend: function submitSend() {
      var _this = this;
      this.$refs.sendForm.validate(function (valid) {
        if (valid) {
          issuedDocGather(_this.sendForm).then(function (res) {
            if (res.data.code == 200) {
              _this.$message.success('分发成功');
              _this.distriVisible = false;
              _this.backPage();
            }
          });
        } else {
          return false;
        }
      });
    },
    handlePreview: function handlePreview(file) {
      var url = file.response.data.url;
      var fileUrl = config.baseUrl + url;
      window.open(config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl)), '_blank');

      // this.previewShow = true;
      // this.previewSrc =
      //       config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl));
    },
    handleDownPreview: function handleDownPreview(file) {
      var _this2 = this;
      var url = file.response.data.url;
      var fileUrl = config.baseUrl + url;
      var formData = new FormData();
      formData.append('filePath', fileUrl);
      downloadFile(formData).then(function (res) {
        _this2.getFile(res.data.message, file.name);
      });
    },
    getFile: function getFile(base64, fileName) {
      var bytes = window.atob(base64),
        n = bytes.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bytes.charCodeAt(n);
      }
      var blob = null;
      if (!window.Blob) alert("当前浏览器不支持该Blob,请升级浏览器或使用Chrome浏览器");else blob = new Blob([u8arr]);
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(url.src, url.name);
      } else {
        var link = document.createElement("a");
        link.setAttribute("href", window.URL.createObjectURL(blob));
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    },
    handleCancel: function handleCancel() {
      this.previewShow = false;
    },
    getProcess: function getProcess() {
      var _this3 = this;
      documentProcess(this.form).then(function (res) {
        if (res.data.code == 200) {
          _this3.flowList = res.data.data;
        }
      });
    },
    loadDocDataByAuditId: function loadDocDataByAuditId() {
      var _this4 = this;
      var that = this;
      var req = {
        auditId: this.form.auditId
      };
      if (this.form.tempId === 1 || this.form.tempId === 2) {
        queryDocTodoDet(req).then(function (res) {
          if (res.data.code == 200) {
            var docData = JSON.parse(res.data.data.docData);
            _this4.form.signImgUrl = docData.draftmanpath;
            _this4.form.tempId = res.data.data.tempId;
            _this4.form.createTime = res.data.data.createTime;
            _this4.form.fileName = res.data.data.fileName;
            _this4.form.fileCode = res.data.data.fileCode;
            _this4.form.secretLevel = res.data.data.secretLevel;
            _this4.form.urgency = res.data.data.urgency;
            _this4.form.docData = docData;
            _this4.form.meetingResult = res.data.data.meetingResult;
            if (docData.annexfilelist.length > 0) {
              for (var i = 0; i < docData.annexfilelist.length; i++) {
                that.form.fileList.push({
                  uid: i,
                  url: docData.annexfilelist[i].annexpath,
                  name: docData.annexfilelist[i].annexname,
                  response: {
                    data: {
                      url: docData.annexfilelist[i].annexpath
                    }
                  }
                });
              }
            }
            var mainDelivery = res.data.data.sendScope.mainDelivery,
              copyDelivery = res.data.data.sendScope.copyDelivery;
            that.form.mainDelivery.organData = [];
            if (mainDelivery.organData.length > 0) {
              for (var i = 0; i < mainDelivery.organData.length; i++) {
                that.form.mainDelivery.organData.push({
                  id: mainDelivery.organData[i].organid,
                  name: mainDelivery.organData[i].organname,
                  typeId: mainDelivery.organData[i].typeid
                });
              }
            }
            if (mainDelivery.postData.length > 0) {
              for (var i = 0; i < mainDelivery.postData.length; i++) {
                that.form.mainDelivery.postData.push({
                  id: mainDelivery.postData[i].postid,
                  name: mainDelivery.postData[i].postname,
                  type: mainDelivery.postData[i].typeid
                });
              }
            }
            if (mainDelivery.userData.length > 0) {
              for (var i = 0; i < mainDelivery.userData.length; i++) {
                that.form.mainDelivery.userData.push({
                  id: mainDelivery.userData[i].userid,
                  name: mainDelivery.userData[i].username,
                  type: mainDelivery.userData[i].typeid
                });
              }
            }
            if (copyDelivery.organData.length > 0) {
              for (var i = 0; i < copyDelivery.organData.length; i++) {
                that.form.copyDelivery.organData.push({
                  id: copyDelivery.organData[i].organid,
                  name: copyDelivery.organData[i].organname,
                  typeId: copyDelivery.organData[i].typeid
                });
              }
            }
            if (copyDelivery.postData.length > 0) {
              for (var i = 0; i < copyDelivery.postData.length; i++) {
                that.form.copyDelivery.postData.push({
                  id: copyDelivery.postData[i].postid,
                  name: copyDelivery.postData[i].postname,
                  type: copyDelivery.postData[i].typeid
                });
              }
            }
            if (copyDelivery.userData.length > 0) {
              for (var i = 0; i < copyDelivery.userData.length; i++) {
                that.form.copyDelivery.userData.push({
                  id: copyDelivery.userData[i].userid,
                  name: copyDelivery.userData[i].username,
                  type: copyDelivery.userData[i].typeid
                });
              }
            }
            _this4.form.mainDelivery = JSON.parse(JSON.stringify(_this4.form.mainDelivery));
            _this4.form.copyDelivery = JSON.parse(JSON.stringify(_this4.form.copyDelivery));
          }
        });
      } else if (this.form.tempId === 3) {
        queryTempThreeContent(req).then(function (res) {
          if (res.data.code == 200) {
            var docData = JSON.parse(res.data.data.docData.value);
            _this4.form.docData = docData;
            if (_this4.form.tempId === 3 && docData.date) {
              _this4.form.formDate = docData.date;
            }
          }
        });
      }
    },
    printTemp: function printTemp() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var that, req, res, frame;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              that = _this5;
              req = {};
              if (that.form.tempId === 1) {
                req = {
                  map: {
                    fileCode: that.form.fileCode,
                    fileName: that.form.fileName,
                    urgency: that.form.urgency,
                    denseLevel: _this5.form.secretLevel,
                    enclosure: that.form.fileNameGroup.join(''),
                    issueOpinion: that.form.docData.signauditopinion,
                    issueSign: that.form.docData.signsignimg,
                    issueTime: that.form.docData.signsigndate,
                    firstOpinion: that.form.docData.firstauditopinion,
                    firstSign: that.form.docData.firstsignimg,
                    firstTime: that.form.docData.firstsigndate,
                    draftSign: that.form.signImgUrl,
                    draftTime: that.form.createTime,
                    mainSend: that.form.zsNameList.join(','),
                    copySend: that.form.csNameList.join(',')
                  },
                  templateName: 'documentTemplate-1.docx',
                  tempId: that.form.tempId
                };
              }
              if (that.form.tempId === 2) {
                req = {
                  map: {
                    fileCode: that.form.fileCode,
                    fileName: that.form.fileName,
                    urgency: that.form.urgency,
                    denseLevel: _this5.form.secretLevel,
                    enclosure: that.form.fileNameGroup.join(','),
                    issueOpinion: that.form.docData.signauditopinion,
                    issueSign: that.form.docData.signsignimg,
                    issueTime: that.form.docData.signsigndate,
                    firstOpinion: that.form.docData.firstauditopinion,
                    firstSign: that.form.docData.firstsignimg,
                    firstTime: that.form.docData.firstsigndate,
                    draftSign: that.form.signImgUrl,
                    draftTime: that.form.createTime,
                    mainSend: that.form.zsNameList.join(','),
                    copySend: that.form.csNameList.join(','),
                    complexOpinion: that.form.docData.secondauditopinion,
                    complexSign: that.form.docData.secondsignimg,
                    complexTime: that.form.docData.secondsigndate
                  },
                  templateName: 'documentTemplate-2.docx',
                  tempId: that.form.tempId
                };
                if (that.form.docData.groupsignsignUser) {
                  req.map.meetingResult = that.form.meetingResult;
                  req.map.meetTime = that.form.docData.groupsignsigndate;
                  if (that.form.docData.meetingImg.length > 0) {
                    req.map.meetingImg = _.join(that.form.docData.meetingImg, ',');
                  }
                }
                if (that.form.docData.proofreadsignimg) {
                  req.map.proofread = that.form.docData.proofreadsignimg;
                }
                if (that.form.docData.printsignimg) {
                  req.map.print = that.form.docData.printsignimg;
                }
                if (that.form.docData.shareency) {
                  req.map.shareency = that.form.docData.shareency;
                }
              }
              if (that.form.tempId === 3) {
                req = {
                  map: {
                    title: that.form.fileName,
                    chairmanOpinion: that.form.docData.chairmanauditopinion,
                    chairmanSign: that.form.docData.chairmansignimg,
                    draftOpinion: that.form.docData.draftauditopinion,
                    draftSign: that.form.docData.draftsignimg,
                    reviewOpinion: that.form.docData.reviewerauditopinion,
                    reviewSign: that.form.docData.reviewersignimg,
                    leaderOpinion: that.form.docData.leadauditopinion,
                    leaderSign: that.form.docData.leadsignimg,
                    copySend: that.form.csNameList.join(','),
                    date: that.form.formDate
                  },
                  templateName: 'documentTemplate-3.docx',
                  tempId: that.form.tempId
                };
              }
              if (that.form.tempId === 4) {
                req = {
                  map: {
                    filename: that.form.fileName,
                    proposedauditopinion: that.form.docData.proposedauditopinion,
                    memorandumauditopinion: that.form.docData.memorandumauditopinion,
                    result: that.form.result,
                    filecode: that.form.fileCode,
                    proposedsigndate: that.form.proposedsigndate,
                    proposedsignimg: that.form.proposedsignimg,
                    memorandumsignimg: that.form.memorandumsignimg,
                    memorandumsigndate: that.form.memorandumsigndate
                  },
                  templateName: 'documentTemplate-4.docx',
                  tempId: that.form.tempId
                };
              }
              _context.n = 1;
              return printDocumentTemplate(req);
            case 1:
              res = _context.v;
              if (res.data.code == 200) {
                _this5.printSrc = res.data.data;
                frame = document.getElementById('printFrame');
                setTimeout(function () {
                  frame.contentWindow.print();
                  // const style = '@page {margin:0mm 20mm;padding:0 0;visibility:visible};'; //打印时去掉眉页眉尾
                  // printJS({
                  //     printable: res.data.data, // 标签元素id
                  //     type: 'pdf',
                  //     header: '',
                  //     targetStyles: ['*'],
                  //     style
                  // });
                }, 1000);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  mounted: function mounted() {
    var _this6 = this;
    var userInfo = this.userInfo;
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList
      };
    });
    var that = this;
    var query = this.$route.query;
    this.needData = JSON.parse(localStorage.getItem('needData'));
    if (JSON.stringify(this.needData) != '{}') {
      Object.assign(this.form, this.needData);
    }
    this.backto = query.backto;
    this.getProcess();
    if (query.look == 'editNewDocumentState') {
      var req = {
        data: {
          id: this.needData.id
        }
      };
      editNewDocumentState(req).then(function (res) {});
    }
    if (query.data.look == 'editSystemNoticeState') {
      editSystemNoticeState(query).then(function (res) {});
      editNewDocumentState(query).then(function (res) {});
    }
    if (this.backto === 'send') {
      this.title = '查看发文';
      getDocumentFillDataById(this.form).then(function (res) {
        if (res.data.code == 200) {
          var docData = {};
          _this6.fillData = res.data.data;
          if (_typeof(res.data.data.docData) === 'object' && res.data.data.docData !== null) {
            docData = JSON.parse(res.data.data.docData.value);
          } else {
            docData = JSON.parse(res.data.data.docData);
          }
          // 签名图片处理成数组
          if (docData.meetingImg && docData.meetingImg.length > 0) {
            docData.meetingImg = _.split(docData.meetingImg, ',');
          } else {
            docData.meetingImg = [];
          }
          _this6.form.docData = docData;
          _this6.form.signImgUrl = docData.draftmanpath;
          _this6.form.tempId = res.data.data.tempId;
          _this6.form.createTime = res.data.data.createTime;
          _this6.form.fileName = res.data.data.fileName;
          _this6.form.fileCode = res.data.data.fileCode;
          _this6.form.secretLevel = res.data.data.secretLevel;
          _this6.form.urgency = res.data.data.urgency;
          _this6.form.meetingResult = res.data.data.meetingResult;
          _this6.form.result = res.data.data.result;
          _this6.form.fileCode = res.data.data.fileCode;
          if (docData.proposedsigndate) {
            _this6.form.proposedsigndate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(docData.proposedsigndate)[0];
          }
          if (docData.memorandumsigndate) {
            _this6.form.memorandumsigndate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(docData.memorandumsigndate)[0];
          }
          _this6.form.proposedsignimg = docData.proposedsignimg;
          _this6.form.memorandumsignimg = docData.memorandumsignimg;
          if (_this6.form.tempId === 3 && docData.date) {
            _this6.form.formDate = docData.date;
          }
          if (docData.annexfilelist && docData.annexfilelist.length > 0) {
            for (var i = 0; i < docData.annexfilelist.length; i++) {
              that.form.fileList.push({
                uid: i,
                url: docData.annexfilelist[i].annexpath,
                name: docData.annexfilelist[i].annexname,
                response: {
                  data: {
                    url: docData.annexfilelist[i].annexpath
                  }
                }
              });
            }
          }
          if (!res.data.data.sendScope.mainDelivery) {
            var _mainDelivery = {
              organData: [],
              postData: [],
              userData: []
            };
            res.data.data.sendScope.mainDelivery = _mainDelivery;
          }
          var mainDelivery = res.data.data.sendScope.mainDelivery,
            copyDelivery = res.data.data.sendScope.copyDelivery;
          that.form.mainDelivery.organData = [];
          if (mainDelivery.organData.length > 0) {
            for (var i = 0; i < mainDelivery.organData.length; i++) {
              that.form.mainDelivery.organData.push({
                id: mainDelivery.organData[i].organid,
                name: mainDelivery.organData[i].organname,
                typeId: mainDelivery.organData[i].typeid
              });
            }
          }
          if (mainDelivery.postData.length > 0) {
            for (var i = 0; i < mainDelivery.postData.length; i++) {
              that.form.mainDelivery.postData.push({
                id: mainDelivery.postData[i].postid,
                name: mainDelivery.postData[i].postname,
                type: mainDelivery.postData[i].typeid
              });
            }
          }
          if (mainDelivery.userData.length > 0) {
            for (var i = 0; i < mainDelivery.userData.length; i++) {
              that.form.mainDelivery.userData.push({
                id: mainDelivery.userData[i].userid,
                name: mainDelivery.userData[i].username,
                type: mainDelivery.userData[i].typeid
              });
            }
          }
          if (copyDelivery.organData.length > 0) {
            for (var i = 0; i < copyDelivery.organData.length; i++) {
              that.form.copyDelivery.organData.push({
                id: copyDelivery.organData[i].organid,
                name: copyDelivery.organData[i].organname,
                typeId: copyDelivery.organData[i].typeid
              });
            }
          }
          if (copyDelivery.postData.length > 0) {
            for (var i = 0; i < copyDelivery.postData.length; i++) {
              that.form.copyDelivery.postData.push({
                id: copyDelivery.postData[i].postid,
                name: copyDelivery.postData[i].postname,
                type: copyDelivery.postData[i].typeid
              });
            }
          }
          if (copyDelivery.userData.length > 0) {
            for (var i = 0; i < copyDelivery.userData.length; i++) {
              that.form.copyDelivery.userData.push({
                id: copyDelivery.userData[i].userid,
                name: copyDelivery.userData[i].username,
                type: copyDelivery.userData[i].typeid
              });
            }
          }
          _this6.form.mainDelivery = JSON.parse(JSON.stringify(_this6.form.mainDelivery));
          _this6.form.copyDelivery = JSON.parse(JSON.stringify(_this6.form.copyDelivery));
        }
      });
    } else if (this.backto === 'put') {
      this.title = '查看收文';
      getDocumentFillDataById(this.form).then(function (res) {
        if (res.data.code == 200) {
          var docData = {};
          _this6.fillData = res.data.data;
          if (_typeof(res.data.data.docData) === 'object' && res.data.data.docData !== null) {
            docData = JSON.parse(res.data.data.docData.value);
          } else {
            docData = JSON.parse(res.data.data.docData);
          }
          // 签名图片处理成数组
          if (docData.meetingImg && docData.meetingImg.length > 0) {
            docData.meetingImg = _.split(docData.meetingImg, ',');
          } else {
            docData.meetingImg = [];
          }
          _this6.form.docData = docData;
          _this6.form.signImgUrl = docData.draftmanpath;
          _this6.form.tempId = res.data.data.tempId;
          _this6.form.createTime = res.data.data.createTime;
          _this6.form.fileName = res.data.data.fileName;
          _this6.form.fileCode = res.data.data.fileCode;
          _this6.form.secretLevel = res.data.data.secretLevel;
          _this6.form.urgency = res.data.data.urgency;
          _this6.form.meetingResult = res.data.data.meetingResult;
          _this6.form.result = res.data.data.result;
          _this6.form.fileCode = res.data.data.fileCode;
          if (docData.proposedsigndate) {
            _this6.form.proposedsigndate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(docData.proposedsigndate)[0];
          }
          if (docData.memorandumsigndate) {
            _this6.form.memorandumsigndate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(docData.memorandumsigndate)[0];
          }
          _this6.form.proposedsignimg = docData.proposedsignimg;
          _this6.form.memorandumsignimg = docData.memorandumsignimg;
          if (_this6.form.tempId === 3 && docData.date) {
            _this6.form.formDate = docData.date;
          }
          if (docData.annexfilelist && docData.annexfilelist.length > 0) {
            for (var i = 0; i < docData.annexfilelist.length; i++) {
              that.form.fileList.push({
                uid: i,
                url: docData.annexfilelist[i].annexpath,
                name: docData.annexfilelist[i].annexname,
                response: {
                  data: {
                    url: docData.annexfilelist[i].annexpath
                  }
                }
              });
            }
          }
          if (!res.data.data.sendScope.mainDelivery) {
            var _mainDelivery2 = {
              organData: [],
              postData: [],
              userData: []
            };
            res.data.data.sendScope.mainDelivery = _mainDelivery2;
          }
          var mainDelivery = res.data.data.sendScope.mainDelivery,
            copyDelivery = res.data.data.sendScope.copyDelivery;
          that.form.mainDelivery.organData = [];
          if (mainDelivery.organData.length > 0) {
            for (var i = 0; i < mainDelivery.organData.length; i++) {
              that.form.mainDelivery.organData.push({
                id: mainDelivery.organData[i].organid,
                name: mainDelivery.organData[i].organname,
                typeId: mainDelivery.organData[i].typeid
              });
            }
          }
          if (mainDelivery.postData.length > 0) {
            for (var i = 0; i < mainDelivery.postData.length; i++) {
              that.form.mainDelivery.postData.push({
                id: mainDelivery.postData[i].postid,
                name: mainDelivery.postData[i].postname,
                type: mainDelivery.postData[i].typeid
              });
            }
          }
          if (mainDelivery.userData.length > 0) {
            for (var i = 0; i < mainDelivery.userData.length; i++) {
              that.form.mainDelivery.userData.push({
                id: mainDelivery.userData[i].userid,
                name: mainDelivery.userData[i].username,
                type: mainDelivery.userData[i].typeid
              });
            }
          }
          if (copyDelivery.organData.length > 0) {
            for (var i = 0; i < copyDelivery.organData.length; i++) {
              that.form.copyDelivery.organData.push({
                id: copyDelivery.organData[i].organid,
                name: copyDelivery.organData[i].organname,
                typeId: copyDelivery.organData[i].typeid
              });
            }
          }
          if (copyDelivery.postData.length > 0) {
            for (var i = 0; i < copyDelivery.postData.length; i++) {
              that.form.copyDelivery.postData.push({
                id: copyDelivery.postData[i].postid,
                name: copyDelivery.postData[i].postname,
                type: copyDelivery.postData[i].typeid
              });
            }
          }
          if (copyDelivery.userData.length > 0) {
            for (var i = 0; i < copyDelivery.userData.length; i++) {
              that.form.copyDelivery.userData.push({
                id: copyDelivery.userData[i].userid,
                name: copyDelivery.userData[i].username,
                type: copyDelivery.userData[i].typeid
              });
            }
          }
          _this6.form.mainDelivery = JSON.parse(JSON.stringify(_this6.form.mainDelivery));
          _this6.form.copyDelivery = JSON.parse(JSON.stringify(_this6.form.copyDelivery));
        }
      });
    } else if (this.backto === 'deal') {
      this.title = '查看待办公文';
      // this.loadDocDataByAuditId();
      getDocumentFillDataById(this.form).then(function (res) {
        if (res.data.code == 200) {
          var docData = {};
          _this6.fillData = res.data.data;
          if (_typeof(res.data.data.docData) === 'object' && res.data.data.docData !== null) {
            docData = JSON.parse(res.data.data.docData.value);
          } else {
            docData = JSON.parse(res.data.data.docData);
          }
          // 签名图片处理成数组
          if (docData.meetingImg && docData.meetingImg.length > 0) {
            docData.meetingImg = _.split(docData.meetingImg, ',');
          } else {
            docData.meetingImg = [];
          }
          _this6.form.docData = docData;
          _this6.form.signImgUrl = docData.draftmanpath;
          _this6.form.tempId = res.data.data.tempId;
          _this6.form.createTime = res.data.data.createTime;
          _this6.form.fileName = res.data.data.fileName;
          _this6.form.fileCode = res.data.data.fileCode;
          _this6.form.secretLevel = res.data.data.secretLevel;
          _this6.form.urgency = res.data.data.urgency;
          _this6.form.meetingResult = res.data.data.meetingResult;
          _this6.form.result = res.data.data.result;
          _this6.form.fileCode = res.data.data.fileCode;
          if (docData.proposedsigndate) {
            _this6.form.proposedsigndate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(docData.proposedsigndate)[0];
          }
          if (docData.memorandumsigndate) {
            _this6.form.memorandumsigndate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(docData.memorandumsigndate)[0];
          }
          _this6.form.proposedsignimg = docData.proposedsignimg;
          _this6.form.memorandumsignimg = docData.memorandumsignimg;
          if (_this6.form.tempId === 3 && docData.date) {
            _this6.form.formDate = docData.date;
          }
          if (docData.annexfilelist && docData.annexfilelist.length > 0) {
            for (var i = 0; i < docData.annexfilelist.length; i++) {
              that.form.fileList.push({
                uid: i,
                url: docData.annexfilelist[i].annexpath,
                name: docData.annexfilelist[i].annexname,
                response: {
                  data: {
                    url: docData.annexfilelist[i].annexpath
                  }
                }
              });
            }
          }
          if (!res.data.data.sendScope.mainDelivery) {
            var _mainDelivery3 = {
              organData: [],
              postData: [],
              userData: []
            };
            res.data.data.sendScope.mainDelivery = _mainDelivery3;
          }
          var mainDelivery = res.data.data.sendScope.mainDelivery,
            copyDelivery = res.data.data.sendScope.copyDelivery;
          that.form.mainDelivery.organData = [];
          if (mainDelivery.organData.length > 0) {
            for (var i = 0; i < mainDelivery.organData.length; i++) {
              that.form.mainDelivery.organData.push({
                id: mainDelivery.organData[i].organid,
                name: mainDelivery.organData[i].organname,
                typeId: mainDelivery.organData[i].typeid
              });
            }
          }
          if (mainDelivery.postData.length > 0) {
            for (var i = 0; i < mainDelivery.postData.length; i++) {
              that.form.mainDelivery.postData.push({
                id: mainDelivery.postData[i].postid,
                name: mainDelivery.postData[i].postname,
                type: mainDelivery.postData[i].typeid
              });
            }
          }
          if (mainDelivery.userData.length > 0) {
            for (var i = 0; i < mainDelivery.userData.length; i++) {
              that.form.mainDelivery.userData.push({
                id: mainDelivery.userData[i].userid,
                name: mainDelivery.userData[i].username,
                type: mainDelivery.userData[i].typeid
              });
            }
          }
          if (copyDelivery.organData.length > 0) {
            for (var i = 0; i < copyDelivery.organData.length; i++) {
              that.form.copyDelivery.organData.push({
                id: copyDelivery.organData[i].organid,
                name: copyDelivery.organData[i].organname,
                typeId: copyDelivery.organData[i].typeid
              });
            }
          }
          if (copyDelivery.postData.length > 0) {
            for (var i = 0; i < copyDelivery.postData.length; i++) {
              that.form.copyDelivery.postData.push({
                id: copyDelivery.postData[i].postid,
                name: copyDelivery.postData[i].postname,
                type: copyDelivery.postData[i].typeid
              });
            }
          }
          if (copyDelivery.userData.length > 0) {
            for (var i = 0; i < copyDelivery.userData.length; i++) {
              that.form.copyDelivery.userData.push({
                id: copyDelivery.userData[i].userid,
                name: copyDelivery.userData[i].username,
                type: copyDelivery.userData[i].typeid
              });
            }
          }
          _this6.form.mainDelivery = JSON.parse(JSON.stringify(_this6.form.mainDelivery));
          _this6.form.copyDelivery = JSON.parse(JSON.stringify(_this6.form.copyDelivery));
        }
      });
    }
  },
  components: {
    selectPerson: selectPerson
  }
};